import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

import {motion} from 'framer-motion';

import {fadeIn} from '../variants';



const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_d1hhrsn', 'template_zn58myj', form.current, 'Viy4ZGSHihQCr6Ly2')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
      alert ("email sent succesfully")
  };

  return (
    <section className=' py-16 lg:section'id='contact'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row'>
          {/* text */}
          <motion.div 
          variants={fadeIn('right', 0.2)}
          initial="hidden"
          whileInView={"show"}
          viewport={{once: false, amount: 0.3}}
          className='flex-1 flex justify-start items-center'>
            <div>
              <h4 className='text-xl uppercase text-accent font-medium mb-2 tracking-wide'>Get in touch</h4> 
              <h2 className='text-[45px] lg:text-[90px] leading-none mb-12'>Let's work <br/> together! </h2>
            </div>
          </motion.div>
          {/* form */}
          <motion.form 
          variants={fadeIn('left', 0.4)}
          initial="hidden"
          whileInView={"show"}
          viewport={{once: false, amount: 0.3}}
          className='flex-1 border rounded-2xl flex flex-col gap-y-6 pb-24 p-6 items-start' ref={form} onSubmit={sendEmail}>
            <input className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all' name='name' type="text" placeholder='Your Name'/>
          
          
            <input className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all' type="email" name='email' placeholder='Your email'/>
          
          <textarea className='bg-transparent border-b py-12 outline-none w-full placeholder:text-white focus:border-accent transition-all resize-none mb-12' name='message' placeholder='your message'></textarea>
          <button className='sbtn sbtn-lg' type="submit" value="Send">send message</button> 
          </motion.form>
        </div>
        <button className='sbtn sbtn-lg'>
            <a href='https://impressum-ec92d.web.app/'> Impressum</a>
          </button>
      </div>
    </section> 
  );
};

export default Contact;

